import { Type } from '../../base/Type/Type';
import Link from '../../base/Link/Link';
import React from 'react';
import { Box } from '../../base/Box/Box';

type PartialLink = { url: string; cached_url: string } & object;

type Props = {
  link: PartialLink;
  linkTitle: string;
};

const Clickable = ({ link, linkTitle }: Props) => (
  <Link
    href={link}
    className="text-p3 font-thin transition-opacity hover:opacity-80"
  >
    {linkTitle}
  </Link>
);

const NonClickable = ({ linkTitle }: Props) => (
  <Box as="div" className="ff-type text-p3 font-thin opacity-60">
    {linkTitle}
  </Box>
);

const isActiveLink = ({ url, cached_url: cachedUrl }: PartialLink) => {
  const urlNotEmpty = url !== '';
  const cachedUrlNotEmpty = cachedUrl !== '';

  return urlNotEmpty || cachedUrlNotEmpty;
};

export const SubLink = (props: Props) => {
  const Component = isActiveLink(props.link) ? Clickable : NonClickable;

  return (
    <Type as="li">
      <Component {...props} />
    </Type>
  );
};
